import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    addFavorite,
    loadWishlists,
    removeFavorite,
} from '../store/e-store/wish-list-slice';
import { useAppDispatch } from './redux-hooks';
import { RootState } from '../store';

export const useIsFavorite = () => {
    const favorites = useSelector((state: RootState) =>
        state.wishlists.favorites ? state.wishlists.favorites! : []
    );
    return (productId: string) => {
        return favorites.some((f) => f.productId === productId);
    };
};

export const useHandleToggleFavorite = () => {
    const isFavorite = useIsFavorite();
    const dispatch = useAppDispatch();
    return (productId: string) => {
        if (isFavorite(productId)) {
            dispatch(removeFavorite(productId));
        } else {
            dispatch(addFavorite(productId));
        }
    };
};

export const useLoadFavorites = () => {
    const favoritesLoaded = useSelector(
        (state: RootState) => state.wishlists.loaded
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!favoritesLoaded) dispatch(loadWishlists());
    }, [favoritesLoaded]);
};
